//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: AuthRequest | undefined, signal?: AbortSignal): Promise<AuthResponse> {
        let url_ = this.baseUrl + "/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponse.fromJS(resultData200);
            return Promise.resolve<AuthResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: RefreshTokenRequest | undefined, signal?: AbortSignal): Promise<RefreshTokenResponse> {
        let url_ = this.baseUrl + "/Auth/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<RefreshTokenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RefreshTokenResponse.fromJS(resultData200);
            return Promise.resolve<RefreshTokenResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RefreshTokenResponse>(null as any);
    }

    /**
     * @return Success
     */
    isLoggedIn(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Auth/is-logged-in";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsLoggedIn(_response);
        });
    }

    protected processIsLoggedIn(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @return Success
     */
    me(signal?: AbortSignal): Promise<MeResponse> {
        let url_ = this.baseUrl + "/Auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<MeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MeResponse.fromJS(resultData200);
            return Promise.resolve<MeResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MeResponse>(null as any);
    }

    /**
     * @return Success
     */
    keepAliveGET(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Auth/keep-alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeepAliveGET(_response);
        });
    }

    protected processKeepAliveGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    keepAliveHEAD(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Auth/keep-alive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "HEAD",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKeepAliveHEAD(_response);
        });
    }

    protected processKeepAliveHEAD(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BudgetItemsTemplateRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addBudgetItemTemplate(body: AddBudgetItemTemplateRequest | undefined, signal?: AbortSignal): Promise<AddBudgetItemTemplateResponse> {
        let url_ = this.baseUrl + "/BudgetItemsTemplate/add-budget-item-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBudgetItemTemplate(_response);
        });
    }

    protected processAddBudgetItemTemplate(response: AxiosResponse): Promise<AddBudgetItemTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddBudgetItemTemplateResponse.fromJS(resultData200);
            return Promise.resolve<AddBudgetItemTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddBudgetItemTemplateResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteBudgetItemTemplate(budgetItemId: number, signal?: AbortSignal): Promise<DeleteBudgetItemTemplateResponse> {
        let url_ = this.baseUrl + "/BudgetItemsTemplate/delete-budget-item-template/{BudgetItemId}";
        if (budgetItemId === undefined || budgetItemId === null)
            throw new Error("The parameter 'budgetItemId' must be defined.");
        url_ = url_.replace("{BudgetItemId}", encodeURIComponent("" + budgetItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteBudgetItemTemplate(_response);
        });
    }

    protected processDeleteBudgetItemTemplate(response: AxiosResponse): Promise<DeleteBudgetItemTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteBudgetItemTemplateResponse.fromJS(resultData200);
            return Promise.resolve<DeleteBudgetItemTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteBudgetItemTemplateResponse>(null as any);
    }

    /**
     * @return Success
     */
    getBudgetItemsTemplates(signal?: AbortSignal): Promise<GetBudgetItemsTemplateResponse> {
        let url_ = this.baseUrl + "/BudgetItemsTemplate/get-budget-items-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetItemsTemplates(_response);
        });
    }

    protected processGetBudgetItemsTemplates(response: AxiosResponse): Promise<GetBudgetItemsTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetItemsTemplateResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetItemsTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetItemsTemplateResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBudgetItemTemplate(body: UpdateBudgetItemTemplateRequest | undefined, signal?: AbortSignal): Promise<UpdateBudgetItemTemplateResponse> {
        let url_ = this.baseUrl + "/BudgetItemsTemplate/update-budget-item-template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBudgetItemTemplate(_response);
        });
    }

    protected processUpdateBudgetItemTemplate(response: AxiosResponse): Promise<UpdateBudgetItemTemplateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBudgetItemTemplateResponse.fromJS(resultData200);
            return Promise.resolve<UpdateBudgetItemTemplateResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBudgetItemTemplateResponse>(null as any);
    }
}

export class FilesRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    filesForProject(projectId: number, signal?: AbortSignal): Promise<GetFilesForProjectResponse> {
        let url_ = this.baseUrl + "/Files/files-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilesForProject(_response);
        });
    }

    protected processFilesForProject(response: AxiosResponse): Promise<GetFilesForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFilesForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetFilesForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFilesForProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFileGetUploadSasUri(body: CreateFileGetUploadSasRequest | undefined, signal?: AbortSignal): Promise<CreateFileGetUploadSasResponse> {
        let url_ = this.baseUrl + "/Files/create-file-get-upload-sas-uri";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFileGetUploadSasUri(_response);
        });
    }

    protected processCreateFileGetUploadSasUri(response: AxiosResponse): Promise<CreateFileGetUploadSasResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateFileGetUploadSasResponse.fromJS(resultData200);
            return Promise.resolve<CreateFileGetUploadSasResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateFileGetUploadSasResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteFile(fileId: number, signal?: AbortSignal): Promise<DeleteFileResponse> {
        let url_ = this.baseUrl + "/Files/delete-file/{FileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{FileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: AxiosResponse): Promise<DeleteFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteFileResponse.fromJS(resultData200);
            return Promise.resolve<DeleteFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteFileResponse>(null as any);
    }

    /**
     * @return Success
     */
    downloadSasToken(fileId: number, signal?: AbortSignal): Promise<GetDownloadSasForFileResponse> {
        let url_ = this.baseUrl + "/Files/download-sas-token/{FileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{FileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSasToken(_response);
        });
    }

    protected processDownloadSasToken(response: AxiosResponse): Promise<GetDownloadSasForFileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDownloadSasForFileResponse.fromJS(resultData200);
            return Promise.resolve<GetDownloadSasForFileResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDownloadSasForFileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getShareLink(fileId: number, signal?: AbortSignal): Promise<GetShareLinkResponse> {
        let url_ = this.baseUrl + "/Files/get-share-link/{FileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{FileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShareLink(_response);
        });
    }

    protected processGetShareLink(response: AxiosResponse): Promise<GetShareLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetShareLinkResponse.fromJS(resultData200);
            return Promise.resolve<GetShareLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetShareLinkResponse>(null as any);
    }
}

export class ModelRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    getModelDownloadLink(modelId: number, signal?: AbortSignal): Promise<GetModelResponse> {
        let url_ = this.baseUrl + "/Model/get-model-download-link/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelDownloadLink(_response);
        });
    }

    protected processGetModelDownloadLink(response: AxiosResponse): Promise<GetModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelResponse.fromJS(resultData200);
            return Promise.resolve<GetModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSasUrlForUploadFragments(body: GetSasUrlForUploadFragmentRequest | undefined, signal?: AbortSignal): Promise<GetSasUrlForUploadFragmentResponse> {
        let url_ = this.baseUrl + "/Model/get-sas-url-for-upload-fragments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForUploadFragments(_response);
        });
    }

    protected processGetSasUrlForUploadFragments(response: AxiosResponse): Promise<GetSasUrlForUploadFragmentResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForUploadFragmentResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForUploadFragmentResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForUploadFragmentResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSasUrlForUploadIfc(body: GetSasUrlForUploadIfcRequest | undefined, signal?: AbortSignal): Promise<GetSasUrlForUploadIfcResponse> {
        let url_ = this.baseUrl + "/Model/get-sas-url-for-upload-ifc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForUploadIfc(_response);
        });
    }

    protected processGetSasUrlForUploadIfc(response: AxiosResponse): Promise<GetSasUrlForUploadIfcResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForUploadIfcResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForUploadIfcResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForUploadIfcResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSasUrlForDownloadIfc(modelId: number, signal?: AbortSignal): Promise<GetSasUrlForDownloadIfcResponse> {
        let url_ = this.baseUrl + "/Model/get-sas-url-for-download-ifc/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForDownloadIfc(_response);
        });
    }

    protected processGetSasUrlForDownloadIfc(response: AxiosResponse): Promise<GetSasUrlForDownloadIfcResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForDownloadIfcResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForDownloadIfcResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForDownloadIfcResponse>(null as any);
    }

    /**
     * @return Success
     */
    getSasUrlForDownloadFragmets(modelId: number, signal?: AbortSignal): Promise<GetSasUrlForDownloadFragmentsResponse> {
        let url_ = this.baseUrl + "/Model/get-sas-url-for-download-fragmets/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSasUrlForDownloadFragmets(_response);
        });
    }

    protected processGetSasUrlForDownloadFragmets(response: AxiosResponse): Promise<GetSasUrlForDownloadFragmentsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSasUrlForDownloadFragmentsResponse.fromJS(resultData200);
            return Promise.resolve<GetSasUrlForDownloadFragmentsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSasUrlForDownloadFragmentsResponse>(null as any);
    }

    /**
     * @return Success
     */
    completeIfcUpload(modelId: number, signal?: AbortSignal): Promise<CompleteIfcUploadResponse> {
        let url_ = this.baseUrl + "/Model/complete-ifc-upload/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteIfcUpload(_response);
        });
    }

    protected processCompleteIfcUpload(response: AxiosResponse): Promise<CompleteIfcUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteIfcUploadResponse.fromJS(resultData200);
            return Promise.resolve<CompleteIfcUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteIfcUploadResponse>(null as any);
    }

    /**
     * @return Success
     */
    completeFragmentsUpload(modelId: number, signal?: AbortSignal): Promise<CompleteFragmentsUploadResponse> {
        let url_ = this.baseUrl + "/Model/complete-fragments-upload/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteFragmentsUpload(_response);
        });
    }

    protected processCompleteFragmentsUpload(response: AxiosResponse): Promise<CompleteFragmentsUploadResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CompleteFragmentsUploadResponse.fromJS(resultData200);
            return Promise.resolve<CompleteFragmentsUploadResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CompleteFragmentsUploadResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelProperties(modelId: number, signal?: AbortSignal): Promise<GetPropertiesForModelResponse> {
        let url_ = this.baseUrl + "/Model/get-model-properties/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelProperties(_response);
        });
    }

    protected processGetModelProperties(response: AxiosResponse): Promise<GetPropertiesForModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForModelResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectModelsProperties(projectId: number, signal?: AbortSignal): Promise<GetPropertiesForProjectModelsResponse> {
        let url_ = this.baseUrl + "/Model/get-project-models-properties/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectModelsProperties(_response);
        });
    }

    protected processGetProjectModelsProperties(response: AxiosResponse): Promise<GetPropertiesForProjectModelsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForProjectModelsResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForProjectModelsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForProjectModelsResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectModelsPropertiesClient(code: string, signal?: AbortSignal): Promise<GetPropertiesForProjectModelsResponse> {
        let url_ = this.baseUrl + "/Model/get-project-models-properties-client/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectModelsPropertiesClient(_response);
        });
    }

    protected processGetProjectModelsPropertiesClient(response: AxiosResponse): Promise<GetPropertiesForProjectModelsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPropertiesForProjectModelsResponse.fromJS(resultData200);
            return Promise.resolve<GetPropertiesForProjectModelsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPropertiesForProjectModelsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pushPropertiesForModel(body: PushPropertiesForModelRequest | undefined, signal?: AbortSignal): Promise<PushPropertiesForModelResponse> {
        let url_ = this.baseUrl + "/Model/push-properties-for-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushPropertiesForModel(_response);
        });
    }

    protected processPushPropertiesForModel(response: AxiosResponse): Promise<PushPropertiesForModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushPropertiesForModelResponse.fromJS(resultData200);
            return Promise.resolve<PushPropertiesForModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushPropertiesForModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    pushModelTree(body: PushTreeDataToModelRequest | undefined, signal?: AbortSignal): Promise<PushTreeDataToModelResponse> {
        let url_ = this.baseUrl + "/Model/push-model-tree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushModelTree(_response);
        });
    }

    protected processPushModelTree(response: AxiosResponse): Promise<PushTreeDataToModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PushTreeDataToModelResponse.fromJS(resultData200);
            return Promise.resolve<PushTreeDataToModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PushTreeDataToModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTree(modelId: number, signal?: AbortSignal): Promise<GetTreeDataFromModelResponse> {
        let url_ = this.baseUrl + "/Model/get-model-tree/{ModelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{ModelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTree(_response);
        });
    }

    protected processGetModelTree(response: AxiosResponse): Promise<GetTreeDataFromModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromModelResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTreeClient(code: string, signal?: AbortSignal): Promise<GetTreeDataFromModelResponse> {
        let url_ = this.baseUrl + "/Model/get-model-tree-client/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTreeClient(_response);
        });
    }

    protected processGetModelTreeClient(response: AxiosResponse): Promise<GetTreeDataFromModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromModelResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromModelResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromModelResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTreesForProject(projectId: number, signal?: AbortSignal): Promise<GetTreeDataFromProjectResponse> {
        let url_ = this.baseUrl + "/Model/get-model-trees-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTreesForProject(_response);
        });
    }

    protected processGetModelTreesForProject(response: AxiosResponse): Promise<GetTreeDataFromProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelTreesForProjectClient(code: string, signal?: AbortSignal): Promise<GetTreeDataFromProjectResponse> {
        let url_ = this.baseUrl + "/Model/get-model-trees-for-project-client/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTreesForProjectClient(_response);
        });
    }

    protected processGetModelTreesForProjectClient(response: AxiosResponse): Promise<GetTreeDataFromProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTreeDataFromProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetTreeDataFromProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTreeDataFromProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    getModelsForProject(projectId: number, signal?: AbortSignal): Promise<GetModelSasUrisFromProjectIdResponse> {
        let url_ = this.baseUrl + "/Model/get-models-for-project/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelsForProject(_response);
        });
    }

    protected processGetModelsForProject(response: AxiosResponse): Promise<GetModelSasUrisFromProjectIdResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetModelSasUrisFromProjectIdResponse.fromJS(resultData200);
            return Promise.resolve<GetModelSasUrisFromProjectIdResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetModelSasUrisFromProjectIdResponse>(null as any);
    }
}

export class PartnersRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addPartner(body: AddPartnerRequest | undefined, signal?: AbortSignal): Promise<AddPartnerResponse> {
        let url_ = this.baseUrl + "/Partners/add-partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPartner(_response);
        });
    }

    protected processAddPartner(response: AxiosResponse): Promise<AddPartnerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddPartnerResponse.fromJS(resultData200);
            return Promise.resolve<AddPartnerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddPartnerResponse>(null as any);
    }

    /**
     * @return Success
     */
    deletePartner(partnerId: number, signal?: AbortSignal): Promise<DeletePartnerResponse> {
        let url_ = this.baseUrl + "/Partners/delete-partner/{PartnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{PartnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePartner(_response);
        });
    }

    protected processDeletePartner(response: AxiosResponse): Promise<DeletePartnerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeletePartnerResponse.fromJS(resultData200);
            return Promise.resolve<DeletePartnerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeletePartnerResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPartners(signal?: AbortSignal): Promise<GetPartnersResponse> {
        let url_ = this.baseUrl + "/Partners/get-partners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartners(_response);
        });
    }

    protected processGetPartners(response: AxiosResponse): Promise<GetPartnersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPartnersResponse.fromJS(resultData200);
            return Promise.resolve<GetPartnersResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnersResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPartnerDetail(partnerId: number, signal?: AbortSignal): Promise<GetPartnerDetailResponse> {
        let url_ = this.baseUrl + "/Partners/get-partner-detail/{PartnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{PartnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPartnerDetail(_response);
        });
    }

    protected processGetPartnerDetail(response: AxiosResponse): Promise<GetPartnerDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPartnerDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetPartnerDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPartnerDetailResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePartner(body: UpdatePartnerRequest | undefined, signal?: AbortSignal): Promise<UpdatePartnerResponse> {
        let url_ = this.baseUrl + "/Partners/update-partner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePartner(_response);
        });
    }

    protected processUpdatePartner(response: AxiosResponse): Promise<UpdatePartnerResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdatePartnerResponse.fromJS(resultData200);
            return Promise.resolve<UpdatePartnerResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdatePartnerResponse>(null as any);
    }
}

export class PrintRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    printReport(projectId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Print/print-report/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintReport(_response);
        });
    }

    protected processPrintReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printBindingOfferReport(projectId: number, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Print/print-binding-offer-report/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintBindingOfferReport(_response);
        });
    }

    protected processPrintBindingOfferReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printReportClient(code: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Print/print-report-client/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintReportClient(_response);
        });
    }

    protected processPrintReportClient(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    printBindingOfferReportClient(code: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Print/print-binding-offer-report-client/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrintBindingOfferReportClient(_response);
        });
    }

    protected processPrintBindingOfferReportClient(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    sendProjectBudget(projectId: number, signal?: AbortSignal): Promise<SendProjectBudgetToClientResponse> {
        let url_ = this.baseUrl + "/Print/send-project-budget/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendProjectBudget(_response);
        });
    }

    protected processSendProjectBudget(response: AxiosResponse): Promise<SendProjectBudgetToClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendProjectBudgetToClientResponse.fromJS(resultData200);
            return Promise.resolve<SendProjectBudgetToClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendProjectBudgetToClientResponse>(null as any);
    }
}

export class ProjectsRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    projectsList(signal?: AbortSignal): Promise<GetProjectsListResponse> {
        let url_ = this.baseUrl + "/Projects/projects-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectsList(_response);
        });
    }

    protected processProjectsList(response: AxiosResponse): Promise<GetProjectsListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsListResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsListResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProject(id: number, signal?: AbortSignal): Promise<GetProjectResponse> {
        let url_ = this.baseUrl + "/Projects/get-project/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: AxiosResponse): Promise<GetProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    projectsListAdmin(userId: number, signal?: AbortSignal): Promise<GetProjectsListAdminForUserResponse> {
        let url_ = this.baseUrl + "/Projects/projects-list-admin/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectsListAdmin(_response);
        });
    }

    protected processProjectsListAdmin(response: AxiosResponse): Promise<GetProjectsListAdminForUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectsListAdminForUserResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectsListAdminForUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectsListAdminForUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createProject(body: CreateProjectRequest | undefined, signal?: AbortSignal): Promise<CreateProjectResponse> {
        let url_ = this.baseUrl + "/Projects/create-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<CreateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateProjectResponse.fromJS(resultData200);
            return Promise.resolve<CreateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProject(body: UpdateProjectRequest | undefined, signal?: AbortSignal): Promise<UpdateProjectResponse> {
        let url_ = this.baseUrl + "/Projects/update-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProject(_response);
        });
    }

    protected processUpdateProject(response: AxiosResponse): Promise<UpdateProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateProjectResponse.fromJS(resultData200);
            return Promise.resolve<UpdateProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateProjectResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteProject(id: number, signal?: AbortSignal): Promise<DeleteProjectResponse> {
        let url_ = this.baseUrl + "/Projects/delete-project/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<DeleteProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteProjectResponse.fromJS(resultData200);
            return Promise.resolve<DeleteProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRemoveProjectUser(body: AddRemoveProjectToUserRequest | undefined, signal?: AbortSignal): Promise<AddRemoveProjectToUserResponse> {
        let url_ = this.baseUrl + "/Projects/add-remove-project-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRemoveProjectUser(_response);
        });
    }

    protected processAddRemoveProjectUser(response: AxiosResponse): Promise<AddRemoveProjectToUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddRemoveProjectToUserResponse.fromJS(resultData200);
            return Promise.resolve<AddRemoveProjectToUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddRemoveProjectToUserResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @param projectId (optional) 
     * @return Success
     */
    uploadProjectImage(file: FileParameter | undefined, projectId: number | undefined, signal?: AbortSignal): Promise<UploadImageForProjectResponse> {
        let url_ = this.baseUrl + "/Projects/upload-project-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (projectId === null || projectId === undefined)
            throw new Error("The parameter 'projectId' cannot be null.");
        else
            content_.append("ProjectId", projectId.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProjectImage(_response);
        });
    }

    protected processUploadProjectImage(response: AxiosResponse): Promise<UploadImageForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadImageForProjectResponse.fromJS(resultData200);
            return Promise.resolve<UploadImageForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadImageForProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    importProjectBudget(body: ImportProjetBudgetRequest | undefined, signal?: AbortSignal): Promise<ImportProjetBudgetResponse> {
        let url_ = this.baseUrl + "/Projects/import-project-budget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportProjectBudget(_response);
        });
    }

    protected processImportProjectBudget(response: AxiosResponse): Promise<ImportProjetBudgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportProjetBudgetResponse.fromJS(resultData200);
            return Promise.resolve<ImportProjetBudgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportProjetBudgetResponse>(null as any);
    }

    /**
     * @return Success
     */
    projectBudget(id: number, signal?: AbortSignal): Promise<GetProjectBudgetResponse> {
        let url_ = this.baseUrl + "/Projects/project-budget/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectBudget(_response);
        });
    }

    protected processProjectBudget(response: AxiosResponse): Promise<GetProjectBudgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectBudgetResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectBudgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectBudgetResponse>(null as any);
    }

    /**
     * @return Success
     */
    projectBudgetItemDetail(id: number, signal?: AbortSignal): Promise<GetBudgetItemDetailResponse> {
        let url_ = this.baseUrl + "/Projects/project-budget-item-detail/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectBudgetItemDetail(_response);
        });
    }

    protected processProjectBudgetItemDetail(response: AxiosResponse): Promise<GetBudgetItemDetailResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetItemDetailResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetItemDetailResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetItemDetailResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param code (optional) 
     * @return Success
     */
    projectBudgetItemDetailClient(id: number | undefined, code: string | undefined, signal?: AbortSignal): Promise<GetBudgetItemDetailClientResponse> {
        let url_ = this.baseUrl + "/Projects/project-budget-item-detail-client?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "Code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectBudgetItemDetailClient(_response);
        });
    }

    protected processProjectBudgetItemDetailClient(response: AxiosResponse): Promise<GetBudgetItemDetailClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetItemDetailClientResponse.fromJS(resultData200);
            return Promise.resolve<GetBudgetItemDetailClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetItemDetailClientResponse>(null as any);
    }

    /**
     * @return Success
     */
    getConsultationEmail(code: string, signal?: AbortSignal): Promise<SendConsultRequestResponse> {
        let url_ = this.baseUrl + "/Projects/get-consultation-email/{Code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{Code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConsultationEmail(_response);
        });
    }

    protected processGetConsultationEmail(response: AxiosResponse): Promise<SendConsultRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendConsultRequestResponse.fromJS(resultData200);
            return Promise.resolve<SendConsultRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendConsultRequestResponse>(null as any);
    }

    /**
     * @return Success
     */
    getOffer(projectId: number, signal?: AbortSignal): Promise<GetOfferDataResponse> {
        let url_ = this.baseUrl + "/Projects/get-offer/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOffer(_response);
        });
    }

    protected processGetOffer(response: AxiosResponse): Promise<GetOfferDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferDataResponse.fromJS(resultData200);
            return Promise.resolve<GetOfferDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferDataResponse>(null as any);
    }

    /**
     * @return Success
     */
    getOfferClient(code: string, signal?: AbortSignal): Promise<GetOfferDataClientResponse> {
        let url_ = this.baseUrl + "/Projects/get-offer-client/{Code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{Code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOfferClient(_response);
        });
    }

    protected processGetOfferClient(response: AxiosResponse): Promise<GetOfferDataClientResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferDataClientResponse.fromJS(resultData200);
            return Promise.resolve<GetOfferDataClientResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferDataClientResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDiscountClient(code: string, signal?: AbortSignal): Promise<SendDiscountRequestResponse> {
        let url_ = this.baseUrl + "/Projects/get-discount-client/{Code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{Code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiscountClient(_response);
        });
    }

    protected processGetDiscountClient(response: AxiosResponse): Promise<SendDiscountRequestResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SendDiscountRequestResponse.fromJS(resultData200);
            return Promise.resolve<SendDiscountRequestResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendDiscountRequestResponse>(null as any);
    }

    /**
     * @return Success
     */
    getProjectClientOfferLink(projectId: number, signal?: AbortSignal): Promise<GetProjectClientOfferLinkResponse> {
        let url_ = this.baseUrl + "/Projects/get-project-client-offer-link/{ProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{ProjectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectClientOfferLink(_response);
        });
    }

    protected processGetProjectClientOfferLink(response: AxiosResponse): Promise<GetProjectClientOfferLinkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectClientOfferLinkResponse.fromJS(resultData200);
            return Promise.resolve<GetProjectClientOfferLinkResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectClientOfferLinkResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateBudgetItemDescriptions(body: UpdateBudgetItemDescriptionsRequest | undefined, signal?: AbortSignal): Promise<UpdateBudgetItemDescriptionsResponse> {
        let url_ = this.baseUrl + "/Projects/update-budget-item-descriptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBudgetItemDescriptions(_response);
        });
    }

    protected processUpdateBudgetItemDescriptions(response: AxiosResponse): Promise<UpdateBudgetItemDescriptionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateBudgetItemDescriptionsResponse.fromJS(resultData200);
            return Promise.resolve<UpdateBudgetItemDescriptionsResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateBudgetItemDescriptionsResponse>(null as any);
    }
}

export class TestRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    emailTest(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/Test/email-test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailTest(_response);
        });
    }

    protected processEmailTest(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class UsersRycApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return Success
     */
    usersList(signal?: AbortSignal): Promise<GetUsersListResponse> {
        let url_ = this.baseUrl + "/Users/users-list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUsersList(_response);
        });
    }

    protected processUsersList(response: AxiosResponse): Promise<GetUsersListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersListResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersListResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateUserRequest | undefined, signal?: AbortSignal): Promise<CreateUserResponse> {
        let url_ = this.baseUrl + "/Users/create-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponse.fromJS(resultData200);
            return Promise.resolve<CreateUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordRequest | undefined, signal?: AbortSignal): Promise<ChangePasswordResponse> {
        let url_ = this.baseUrl + "/Users/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ChangePasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChangePasswordResponse.fromJS(resultData200);
            return Promise.resolve<ChangePasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChangePasswordResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserRequest | undefined, signal?: AbortSignal): Promise<UpdateUserResponse> {
        let url_ = this.baseUrl + "/Users/update-user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UpdateUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateUserResponse.fromJS(resultData200);
            return Promise.resolve<UpdateUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateUserResponse>(null as any);
    }

    /**
     * @return Success
     */
    deleteUser(id: number, signal?: AbortSignal): Promise<DeleteUserResponse> {
        let url_ = this.baseUrl + "/Users/delete-user/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<DeleteUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteUserResponse.fromJS(resultData200);
            return Promise.resolve<DeleteUserResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteUserResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPasswordAdmin(body: ResetPasswordAdminRequest | undefined, signal?: AbortSignal): Promise<ResetPasswordAdminResponse> {
        let url_ = this.baseUrl + "/Users/reset-password-admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPasswordAdmin(_response);
        });
    }

    protected processResetPasswordAdmin(response: AxiosResponse): Promise<ResetPasswordAdminResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordAdminResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordAdminResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordAdminResponse>(null as any);
    }

    /**
     * @return Success
     */
    getUsersForProject(id: number, signal?: AbortSignal): Promise<GetUsersForProjectResponse> {
        let url_ = this.baseUrl + "/Users/get-users-for-project/{Id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{Id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForProject(_response);
        });
    }

    protected processGetUsersForProject(response: AxiosResponse): Promise<GetUsersForProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetUsersForProjectResponse.fromJS(resultData200);
            return Promise.resolve<GetUsersForProjectResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetUsersForProjectResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordRequest | undefined, signal?: AbortSignal): Promise<ResetPasswordResponse> {
        let url_ = this.baseUrl + "/Users/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ResetPasswordResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordResponse.fromJS(resultData200);
            return Promise.resolve<ResetPasswordResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordResponse>(null as any);
    }
}

export class AddBudgetItemTemplateRequest implements IAddBudgetItemTemplateRequest {
    budgetItem?: BudgetItemTemplateDto;

    constructor(data?: IAddBudgetItemTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetItem = _data["budgetItem"] ? BudgetItemTemplateDto.fromJS(_data["budgetItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddBudgetItemTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBudgetItemTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetItem"] = this.budgetItem ? this.budgetItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddBudgetItemTemplateRequest {
    budgetItem?: BudgetItemTemplateDto;
}

export class AddBudgetItemTemplateResponse implements IAddBudgetItemTemplateResponse {
    budgetItemNew?: BudgetItemTemplateDto;

    constructor(data?: IAddBudgetItemTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetItemNew = _data["budgetItemNew"] ? BudgetItemTemplateDto.fromJS(_data["budgetItemNew"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddBudgetItemTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddBudgetItemTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetItemNew"] = this.budgetItemNew ? this.budgetItemNew.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddBudgetItemTemplateResponse {
    budgetItemNew?: BudgetItemTemplateDto;
}

export class AddPartnerRequest implements IAddPartnerRequest {
    partner?: PartnerDto;

    constructor(data?: IAddPartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerDto.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddPartnerRequest {
    partner?: PartnerDto;
}

export class AddPartnerResponse implements IAddPartnerResponse {
    partnerNew?: PartnerDto;

    constructor(data?: IAddPartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerNew = _data["partnerNew"] ? PartnerDto.fromJS(_data["partnerNew"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddPartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerNew"] = this.partnerNew ? this.partnerNew.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddPartnerResponse {
    partnerNew?: PartnerDto;
}

export class AddRemoveProjectToUserRequest implements IAddRemoveProjectToUserRequest {
    projectId?: number;
    userId?: number;

    constructor(data?: IAddRemoveProjectToUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AddRemoveProjectToUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveProjectToUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddRemoveProjectToUserRequest {
    projectId?: number;
    userId?: number;
}

export class AddRemoveProjectToUserResponse implements IAddRemoveProjectToUserResponse {
    newValue?: boolean;

    constructor(data?: IAddRemoveProjectToUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newValue = _data["newValue"];
        }
    }

    static fromJS(data: any): AddRemoveProjectToUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemoveProjectToUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newValue"] = this.newValue;
        return data;
    }
}

export interface IAddRemoveProjectToUserResponse {
    newValue?: boolean;
}

export class AuthRequest implements IAuthRequest {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAuthRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthRequest {
    email?: string | undefined;
    password?: string | undefined;
}

export class AuthResponse implements IAuthResponse {
    needPasswordReset?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    userId?: number | undefined;
    tokenExpires?: Date;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.needPasswordReset = _data["needPasswordReset"];
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.userId = _data["userId"];
            this.tokenExpires = _data["tokenExpires"] ? new Date(_data["tokenExpires"].toString()) : <any>undefined;
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needPasswordReset"] = this.needPasswordReset;
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["userId"] = this.userId;
        data["tokenExpires"] = this.tokenExpires ? this.tokenExpires.toISOString() : <any>undefined;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IAuthResponse {
    needPasswordReset?: boolean;
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    userId?: number | undefined;
    tokenExpires?: Date;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export class BudgetItemTemplateDto implements IBudgetItemTemplateDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    contractDescription?: string | undefined;

    constructor(data?: IBudgetItemTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.contractDescription = _data["contractDescription"];
        }
    }

    static fromJS(data: any): BudgetItemTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetItemTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["description"] = this.description;
        data["contractDescription"] = this.contractDescription;
        return data;
    }
}

export interface IBudgetItemTemplateDto {
    id?: number;
    code?: string | undefined;
    description?: string | undefined;
    contractDescription?: string | undefined;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    originalPassword?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalPassword = _data["originalPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalPassword"] = this.originalPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordRequest {
    originalPassword?: string | undefined;
    newPassword?: string | undefined;
}

export class ChangePasswordResponse implements IChangePasswordResponse {
    ok?: boolean;

    constructor(data?: IChangePasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ChangePasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IChangePasswordResponse {
    ok?: boolean;
}

export class CompleteFragmentsUploadResponse implements ICompleteFragmentsUploadResponse {
    completedTime?: Date;

    constructor(data?: ICompleteFragmentsUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedTime = _data["completedTime"] ? new Date(_data["completedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteFragmentsUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteFragmentsUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICompleteFragmentsUploadResponse {
    completedTime?: Date;
}

export class CompleteIfcUploadResponse implements ICompleteIfcUploadResponse {
    completedTime?: Date;

    constructor(data?: ICompleteIfcUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completedTime = _data["completedTime"] ? new Date(_data["completedTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteIfcUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteIfcUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completedTime"] = this.completedTime ? this.completedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICompleteIfcUploadResponse {
    completedTime?: Date;
}

export class CreateFileGetUploadSasRequest implements ICreateFileGetUploadSasRequest {
    fileName?: string | undefined;
    projectId?: number;

    constructor(data?: ICreateFileGetUploadSasRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateFileGetUploadSasRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileGetUploadSasRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateFileGetUploadSasRequest {
    fileName?: string | undefined;
    projectId?: number;
}

export class CreateFileGetUploadSasResponse implements ICreateFileGetUploadSasResponse {
    id?: number;
    sasToken?: string | undefined;

    constructor(data?: ICreateFileGetUploadSasResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sasToken = _data["sasToken"];
        }
    }

    static fromJS(data: any): CreateFileGetUploadSasResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileGetUploadSasResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sasToken"] = this.sasToken;
        return data;
    }
}

export interface ICreateFileGetUploadSasResponse {
    id?: number;
    sasToken?: string | undefined;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    name?: string | undefined;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateProjectRequest {
    name?: string | undefined;
}

export class CreateProjectResponse implements ICreateProjectResponse {
    projectId?: number;

    constructor(data?: ICreateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface ICreateProjectResponse {
    projectId?: number;
}

export class CreateUserRequest implements ICreateUserRequest {
    email?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface ICreateUserRequest {
    email?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export class CreateUserResponse implements ICreateUserResponse {
    userId?: number | undefined;
    temporaryPassword?: string | undefined;

    constructor(data?: ICreateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.temporaryPassword = _data["temporaryPassword"];
        }
    }

    static fromJS(data: any): CreateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["temporaryPassword"] = this.temporaryPassword;
        return data;
    }
}

export interface ICreateUserResponse {
    userId?: number | undefined;
    temporaryPassword?: string | undefined;
}

export class DataPropertyDto implements IDataPropertyDto {
    propertySetName?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numberOfDigits?: number | undefined;
    unit?: string | undefined;

    constructor(data?: IDataPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertySetName = _data["propertySetName"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.numberOfDigits = _data["numberOfDigits"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): DataPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertySetName"] = this.propertySetName;
        data["name"] = this.name;
        data["value"] = this.value;
        data["numberOfDigits"] = this.numberOfDigits;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IDataPropertyDto {
    propertySetName?: string | undefined;
    name?: string | undefined;
    value?: string | undefined;
    numberOfDigits?: number | undefined;
    unit?: string | undefined;
}

export class DeleteBudgetItemTemplateResponse implements IDeleteBudgetItemTemplateResponse {
    success?: boolean;

    constructor(data?: IDeleteBudgetItemTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeleteBudgetItemTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteBudgetItemTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeleteBudgetItemTemplateResponse {
    success?: boolean;
}

export class DeleteFileResponse implements IDeleteFileResponse {
    ok?: boolean;

    constructor(data?: IDeleteFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteFileResponse {
    ok?: boolean;
}

export class DeletePartnerResponse implements IDeletePartnerResponse {
    success?: boolean;

    constructor(data?: IDeletePartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): DeletePartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IDeletePartnerResponse {
    success?: boolean;
}

export class DeleteProjectResponse implements IDeleteProjectResponse {
    ok?: boolean;

    constructor(data?: IDeleteProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteProjectResponse {
    ok?: boolean;
}

export class DeleteUserResponse implements IDeleteUserResponse {
    ok?: boolean;

    constructor(data?: IDeleteUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): DeleteUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IDeleteUserResponse {
    ok?: boolean;
}

export class FileDto implements IFileDto {
    id?: number;
    name?: string | undefined;
    extension?: string | undefined;
    created?: Date;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFileDto {
    id?: number;
    name?: string | undefined;
    extension?: string | undefined;
    created?: Date;
}

export class FileForOfferDto implements IFileForOfferDto {
    id?: number;
    name?: string | undefined;
    fileDownloadUri?: string | undefined;

    constructor(data?: IFileForOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fileDownloadUri = _data["fileDownloadUri"];
        }
    }

    static fromJS(data: any): FileForOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileForOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fileDownloadUri"] = this.fileDownloadUri;
        return data;
    }
}

export interface IFileForOfferDto {
    id?: number;
    name?: string | undefined;
    fileDownloadUri?: string | undefined;
}

export class GetBudgetItemDetailClientResponse implements IGetBudgetItemDetailClientResponse {
    description?: string | undefined;
    contractDescription?: string | undefined;

    constructor(data?: IGetBudgetItemDetailClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.contractDescription = _data["contractDescription"];
        }
    }

    static fromJS(data: any): GetBudgetItemDetailClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetItemDetailClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["contractDescription"] = this.contractDescription;
        return data;
    }
}

export interface IGetBudgetItemDetailClientResponse {
    description?: string | undefined;
    contractDescription?: string | undefined;
}

export class GetBudgetItemDetailResponse implements IGetBudgetItemDetailResponse {
    description?: string | undefined;
    contractDescription?: string | undefined;

    constructor(data?: IGetBudgetItemDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.contractDescription = _data["contractDescription"];
        }
    }

    static fromJS(data: any): GetBudgetItemDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetItemDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["contractDescription"] = this.contractDescription;
        return data;
    }
}

export interface IGetBudgetItemDetailResponse {
    description?: string | undefined;
    contractDescription?: string | undefined;
}

export class GetBudgetItemsTemplateResponse implements IGetBudgetItemsTemplateResponse {
    budgetItems?: BudgetItemTemplateDto[] | undefined;

    constructor(data?: IGetBudgetItemsTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetItems"])) {
                this.budgetItems = [] as any;
                for (let item of _data["budgetItems"])
                    this.budgetItems!.push(BudgetItemTemplateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBudgetItemsTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetItemsTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetItems)) {
            data["budgetItems"] = [];
            for (let item of this.budgetItems)
                data["budgetItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetBudgetItemsTemplateResponse {
    budgetItems?: BudgetItemTemplateDto[] | undefined;
}

export class GetDownloadSasForFileResponse implements IGetDownloadSasForFileResponse {
    sasToken?: string | undefined;

    constructor(data?: IGetDownloadSasForFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sasToken = _data["sasToken"];
        }
    }

    static fromJS(data: any): GetDownloadSasForFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDownloadSasForFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sasToken"] = this.sasToken;
        return data;
    }
}

export interface IGetDownloadSasForFileResponse {
    sasToken?: string | undefined;
}

export class GetFilesForProjectResponse implements IGetFilesForProjectResponse {
    files?: FileDto[] | undefined;

    constructor(data?: IGetFilesForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetFilesForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFilesForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetFilesForProjectResponse {
    files?: FileDto[] | undefined;
}

export class GetModelResponse implements IGetModelResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetModelResponse {
    modelUri?: string | undefined;
}

export class GetModelSasUrisFromProjectIdResponse implements IGetModelSasUrisFromProjectIdResponse {
    modelUris?: ModelUrisDto[] | undefined;

    constructor(data?: IGetModelSasUrisFromProjectIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modelUris"])) {
                this.modelUris = [] as any;
                for (let item of _data["modelUris"])
                    this.modelUris!.push(ModelUrisDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetModelSasUrisFromProjectIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelSasUrisFromProjectIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modelUris)) {
            data["modelUris"] = [];
            for (let item of this.modelUris)
                data["modelUris"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetModelSasUrisFromProjectIdResponse {
    modelUris?: ModelUrisDto[] | undefined;
}

export class GetOfferDataClientResponse implements IGetOfferDataClientResponse {
    offerData?: GetOfferDataResponse;
    modelData?: GetModelSasUrisFromProjectIdResponse;

    constructor(data?: IGetOfferDataClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerData = _data["offerData"] ? GetOfferDataResponse.fromJS(_data["offerData"]) : <any>undefined;
            this.modelData = _data["modelData"] ? GetModelSasUrisFromProjectIdResponse.fromJS(_data["modelData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOfferDataClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferDataClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerData"] = this.offerData ? this.offerData.toJSON() : <any>undefined;
        data["modelData"] = this.modelData ? this.modelData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetOfferDataClientResponse {
    offerData?: GetOfferDataResponse;
    modelData?: GetModelSasUrisFromProjectIdResponse;
}

export class GetOfferDataResponse implements IGetOfferDataResponse {
    projectName?: string | undefined;
    orderNumber?: string | undefined;
    fullPrice?: number;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    landType?: LandType;
    longitudeOfBelts?: number;
    area?: number;
    undergroundMaterial?: string | undefined;
    budgetItems?: ProjectBudgetDTO[] | undefined;
    files?: FileForOfferDto[] | undefined;
    imageUri?: string | undefined;

    constructor(data?: IGetOfferDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectName = _data["projectName"];
            this.orderNumber = _data["orderNumber"];
            this.fullPrice = _data["fullPrice"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.landType = _data["landType"];
            this.longitudeOfBelts = _data["longitudeOfBelts"];
            this.area = _data["area"];
            this.undergroundMaterial = _data["undergroundMaterial"];
            if (Array.isArray(_data["budgetItems"])) {
                this.budgetItems = [] as any;
                for (let item of _data["budgetItems"])
                    this.budgetItems!.push(ProjectBudgetDTO.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileForOfferDto.fromJS(item));
            }
            this.imageUri = _data["imageUri"];
        }
    }

    static fromJS(data: any): GetOfferDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectName"] = this.projectName;
        data["orderNumber"] = this.orderNumber;
        data["fullPrice"] = this.fullPrice;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["landType"] = this.landType;
        data["longitudeOfBelts"] = this.longitudeOfBelts;
        data["area"] = this.area;
        data["undergroundMaterial"] = this.undergroundMaterial;
        if (Array.isArray(this.budgetItems)) {
            data["budgetItems"] = [];
            for (let item of this.budgetItems)
                data["budgetItems"].push(item.toJSON());
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["imageUri"] = this.imageUri;
        return data;
    }
}

export interface IGetOfferDataResponse {
    projectName?: string | undefined;
    orderNumber?: string | undefined;
    fullPrice?: number;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    landType?: LandType;
    longitudeOfBelts?: number;
    area?: number;
    undergroundMaterial?: string | undefined;
    budgetItems?: ProjectBudgetDTO[] | undefined;
    files?: FileForOfferDto[] | undefined;
    imageUri?: string | undefined;
}

export class GetPartnerDetailResponse implements IGetPartnerDetailResponse {
    partner?: PartnerDto;

    constructor(data?: IGetPartnerDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerDto.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPartnerDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnerDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPartnerDetailResponse {
    partner?: PartnerDto;
}

export class GetPartnersResponse implements IGetPartnersResponse {
    partners?: PartnerDto[] | undefined;

    constructor(data?: IGetPartnersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(PartnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPartnersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPartnersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPartnersResponse {
    partners?: PartnerDto[] | undefined;
}

export class GetProjectBudgetResponse implements IGetProjectBudgetResponse {
    budgetItems?: ProjectBudgetDTO[] | undefined;
    fullPrice?: number;

    constructor(data?: IGetProjectBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgetItems"])) {
                this.budgetItems = [] as any;
                for (let item of _data["budgetItems"])
                    this.budgetItems!.push(ProjectBudgetDTO.fromJS(item));
            }
            this.fullPrice = _data["fullPrice"];
        }
    }

    static fromJS(data: any): GetProjectBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgetItems)) {
            data["budgetItems"] = [];
            for (let item of this.budgetItems)
                data["budgetItems"].push(item.toJSON());
        }
        data["fullPrice"] = this.fullPrice;
        return data;
    }
}

export interface IGetProjectBudgetResponse {
    budgetItems?: ProjectBudgetDTO[] | undefined;
    fullPrice?: number;
}

export class GetProjectClientOfferLinkResponse implements IGetProjectClientOfferLinkResponse {
    offerUrl?: string | undefined;

    constructor(data?: IGetProjectClientOfferLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerUrl = _data["offerUrl"];
        }
    }

    static fromJS(data: any): GetProjectClientOfferLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectClientOfferLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerUrl"] = this.offerUrl;
        return data;
    }
}

export interface IGetProjectClientOfferLinkResponse {
    offerUrl?: string | undefined;
}

export class GetProjectResponse implements IGetProjectResponse {
    project?: ProjectDto;

    constructor(data?: IGetProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProjectResponse {
    project?: ProjectDto;
}

export class GetProjectsListAdminForUserResponse implements IGetProjectsListAdminForUserResponse {
    projects?: ProjectForAdminDto[] | undefined;

    constructor(data?: IGetProjectsListAdminForUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectForAdminDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsListAdminForUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsListAdminForUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsListAdminForUserResponse {
    projects?: ProjectForAdminDto[] | undefined;
}

export class GetProjectsListResponse implements IGetProjectsListResponse {
    projects?: ProjectDto[] | undefined;

    constructor(data?: IGetProjectsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetProjectsListResponse {
    projects?: ProjectDto[] | undefined;
}

export class GetPropertiesForModelResponse implements IGetPropertiesForModelResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;

    constructor(data?: IGetPropertiesForModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPropertiesForModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface IGetPropertiesForModelResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
}

export class GetPropertiesForProjectModelsResponse implements IGetPropertiesForProjectModelsResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;

    constructor(data?: IGetPropertiesForProjectModelsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(item);
            }
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPropertiesForProjectModelsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertiesForProjectModelsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item);
        }
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface IGetPropertiesForProjectModelsResponse {
    elements?: { [key: string]: any; }[] | undefined;
    columns?: string[] | undefined;
}

export class GetSasUrlForDownloadFragmentsResponse implements IGetSasUrlForDownloadFragmentsResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForDownloadFragmentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForDownloadFragmentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForDownloadFragmentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForDownloadFragmentsResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForDownloadIfcResponse implements IGetSasUrlForDownloadIfcResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForDownloadIfcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForDownloadIfcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForDownloadIfcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForDownloadIfcResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForUploadFragmentRequest implements IGetSasUrlForUploadFragmentRequest {
    id?: number;

    constructor(data?: IGetSasUrlForUploadFragmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadFragmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadFragmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IGetSasUrlForUploadFragmentRequest {
    id?: number;
}

export class GetSasUrlForUploadFragmentResponse implements IGetSasUrlForUploadFragmentResponse {
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForUploadFragmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadFragmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadFragmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForUploadFragmentResponse {
    modelUri?: string | undefined;
}

export class GetSasUrlForUploadIfcRequest implements IGetSasUrlForUploadIfcRequest {
    name?: string | undefined;
    projectId?: number;

    constructor(data?: IGetSasUrlForUploadIfcRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadIfcRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadIfcRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IGetSasUrlForUploadIfcRequest {
    name?: string | undefined;
    projectId?: number;
}

export class GetSasUrlForUploadIfcResponse implements IGetSasUrlForUploadIfcResponse {
    id?: number;
    modelUri?: string | undefined;

    constructor(data?: IGetSasUrlForUploadIfcResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): GetSasUrlForUploadIfcResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSasUrlForUploadIfcResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IGetSasUrlForUploadIfcResponse {
    id?: number;
    modelUri?: string | undefined;
}

export class GetShareLinkResponse implements IGetShareLinkResponse {
    link?: string | undefined;

    constructor(data?: IGetShareLinkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.link = _data["link"];
        }
    }

    static fromJS(data: any): GetShareLinkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetShareLinkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["link"] = this.link;
        return data;
    }
}

export interface IGetShareLinkResponse {
    link?: string | undefined;
}

export class GetTreeDataFromModelResponse implements IGetTreeDataFromModelResponse {
    ifcTree?: string | undefined;

    constructor(data?: IGetTreeDataFromModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ifcTree = _data["ifcTree"];
        }
    }

    static fromJS(data: any): GetTreeDataFromModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeDataFromModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifcTree"] = this.ifcTree;
        return data;
    }
}

export interface IGetTreeDataFromModelResponse {
    ifcTree?: string | undefined;
}

export class GetTreeDataFromProjectResponse implements IGetTreeDataFromProjectResponse {
    modelTrees?: ModelTreeDto[] | undefined;

    constructor(data?: IGetTreeDataFromProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modelTrees"])) {
                this.modelTrees = [] as any;
                for (let item of _data["modelTrees"])
                    this.modelTrees!.push(ModelTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTreeDataFromProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTreeDataFromProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modelTrees)) {
            data["modelTrees"] = [];
            for (let item of this.modelTrees)
                data["modelTrees"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTreeDataFromProjectResponse {
    modelTrees?: ModelTreeDto[] | undefined;
}

export class GetUsersForProjectResponse implements IGetUsersForProjectResponse {
    users?: UserForProjectDto[] | undefined;

    constructor(data?: IGetUsersForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserForProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersForProjectResponse {
    users?: UserForProjectDto[] | undefined;
}

export class GetUsersListResponse implements IGetUsersListResponse {
    users?: UserDto[] | undefined;

    constructor(data?: IGetUsersListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUsersListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUsersListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUsersListResponse {
    users?: UserDto[] | undefined;
}

export class ImportProjetBudgetRequest implements IImportProjetBudgetRequest {
    projectId?: number;
    budgetItems?: ProjectBudgetDTO[] | undefined;

    constructor(data?: IImportProjetBudgetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["budgetItems"])) {
                this.budgetItems = [] as any;
                for (let item of _data["budgetItems"])
                    this.budgetItems!.push(ProjectBudgetDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportProjetBudgetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProjetBudgetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        if (Array.isArray(this.budgetItems)) {
            data["budgetItems"] = [];
            for (let item of this.budgetItems)
                data["budgetItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IImportProjetBudgetRequest {
    projectId?: number;
    budgetItems?: ProjectBudgetDTO[] | undefined;
}

export class ImportProjetBudgetResponse implements IImportProjetBudgetResponse {
    ok?: boolean;

    constructor(data?: IImportProjetBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ImportProjetBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportProjetBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IImportProjetBudgetResponse {
    ok?: boolean;
}

export enum LandType {
    Flat = 1,
    Cross = 2,
    Dig = 3,
    LongFlat = 4,
}

export class MeResponse implements IMeResponse {
    userId?: number | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    initials?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: IMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.initials = _data["initials"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): MeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["initials"] = this.initials;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IMeResponse {
    userId?: number | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    initials?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export class ModelTreeDto implements IModelTreeDto {
    ifcTree?: string | undefined;
    modelId?: number;

    constructor(data?: IModelTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ifcTree = _data["ifcTree"];
            this.modelId = _data["modelId"];
        }
    }

    static fromJS(data: any): ModelTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ifcTree"] = this.ifcTree;
        data["modelId"] = this.modelId;
        return data;
    }
}

export interface IModelTreeDto {
    ifcTree?: string | undefined;
    modelId?: number;
}

export class ModelUrisDto implements IModelUrisDto {
    modelId?: number;
    modelName?: string | undefined;
    modelUri?: string | undefined;

    constructor(data?: IModelUrisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.modelUri = _data["modelUri"];
        }
    }

    static fromJS(data: any): ModelUrisDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelUrisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["modelUri"] = this.modelUri;
        return data;
    }
}

export interface IModelUrisDto {
    modelId?: number;
    modelName?: string | undefined;
    modelUri?: string | undefined;
}

export class PartnerDto implements IPartnerDto {
    id?: number;
    name?: string | undefined;
    isCompany?: boolean;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    ico?: string | undefined;
    bankId?: string | undefined;
    director?: string | undefined;
    businessRegistry?: string | undefined;
    isUsed?: boolean;

    constructor(data?: IPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isCompany = _data["isCompany"];
            this.address = _data["address"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.ico = _data["ico"];
            this.bankId = _data["bankId"];
            this.director = _data["director"];
            this.businessRegistry = _data["businessRegistry"];
            this.isUsed = _data["isUsed"];
        }
    }

    static fromJS(data: any): PartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isCompany"] = this.isCompany;
        data["address"] = this.address;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["ico"] = this.ico;
        data["bankId"] = this.bankId;
        data["director"] = this.director;
        data["businessRegistry"] = this.businessRegistry;
        data["isUsed"] = this.isUsed;
        return data;
    }
}

export interface IPartnerDto {
    id?: number;
    name?: string | undefined;
    isCompany?: boolean;
    address?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    ico?: string | undefined;
    bankId?: string | undefined;
    director?: string | undefined;
    businessRegistry?: string | undefined;
    isUsed?: boolean;
}

export class ProjectBudgetDTO implements IProjectBudgetDTO {
    id?: number;
    orderNumber?: string | undefined;
    orderNumberSecond?: string | undefined;
    itemCode?: string | undefined;
    itemName?: string | undefined;
    amount?: number;
    unitPrice?: number;
    readonly totalPrice?: number;
    objectName?: string | undefined;
    partName?: string | undefined;
    description?: string | undefined;
    contractDescription?: string | undefined;

    constructor(data?: IProjectBudgetDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderNumber = _data["orderNumber"];
            this.orderNumberSecond = _data["orderNumberSecond"];
            this.itemCode = _data["itemCode"];
            this.itemName = _data["itemName"];
            this.amount = _data["amount"];
            this.unitPrice = _data["unitPrice"];
            (<any>this).totalPrice = _data["totalPrice"];
            this.objectName = _data["objectName"];
            this.partName = _data["partName"];
            this.description = _data["description"];
            this.contractDescription = _data["contractDescription"];
        }
    }

    static fromJS(data: any): ProjectBudgetDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBudgetDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderNumber"] = this.orderNumber;
        data["orderNumberSecond"] = this.orderNumberSecond;
        data["itemCode"] = this.itemCode;
        data["itemName"] = this.itemName;
        data["amount"] = this.amount;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        data["objectName"] = this.objectName;
        data["partName"] = this.partName;
        data["description"] = this.description;
        data["contractDescription"] = this.contractDescription;
        return data;
    }
}

export interface IProjectBudgetDTO {
    id?: number;
    orderNumber?: string | undefined;
    orderNumberSecond?: string | undefined;
    itemCode?: string | undefined;
    itemName?: string | undefined;
    amount?: number;
    unitPrice?: number;
    totalPrice?: number;
    objectName?: string | undefined;
    partName?: string | undefined;
    description?: string | undefined;
    contractDescription?: string | undefined;
}

export class ProjectDto implements IProjectDto {
    id?: number;
    name?: string | undefined;
    orderNumber?: string | undefined;
    description?: string | undefined;
    partnerName?: string | undefined;
    partnerContactEmail?: string | undefined;
    partnerContactPhone?: string | undefined;
    imageUri?: string | undefined;
    ordererPartnerId?: number | undefined;
    supplierPartnerId?: number | undefined;
    undergroundMaterial?: UndergroundMaterial;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    landType?: LandType;
    longitudeOfBelts?: number;
    area?: number;
    totalPrice?: number;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.description = _data["description"];
            this.partnerName = _data["partnerName"];
            this.partnerContactEmail = _data["partnerContactEmail"];
            this.partnerContactPhone = _data["partnerContactPhone"];
            this.imageUri = _data["imageUri"];
            this.ordererPartnerId = _data["ordererPartnerId"];
            this.supplierPartnerId = _data["supplierPartnerId"];
            this.undergroundMaterial = _data["undergroundMaterial"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.landType = _data["landType"];
            this.longitudeOfBelts = _data["longitudeOfBelts"];
            this.area = _data["area"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["description"] = this.description;
        data["partnerName"] = this.partnerName;
        data["partnerContactEmail"] = this.partnerContactEmail;
        data["partnerContactPhone"] = this.partnerContactPhone;
        data["imageUri"] = this.imageUri;
        data["ordererPartnerId"] = this.ordererPartnerId;
        data["supplierPartnerId"] = this.supplierPartnerId;
        data["undergroundMaterial"] = this.undergroundMaterial;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["landType"] = this.landType;
        data["longitudeOfBelts"] = this.longitudeOfBelts;
        data["area"] = this.area;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IProjectDto {
    id?: number;
    name?: string | undefined;
    orderNumber?: string | undefined;
    description?: string | undefined;
    partnerName?: string | undefined;
    partnerContactEmail?: string | undefined;
    partnerContactPhone?: string | undefined;
    imageUri?: string | undefined;
    ordererPartnerId?: number | undefined;
    supplierPartnerId?: number | undefined;
    undergroundMaterial?: UndergroundMaterial;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    landType?: LandType;
    longitudeOfBelts?: number;
    area?: number;
    totalPrice?: number;
}

export class ProjectForAdminDto implements IProjectForAdminDto {
    id?: number;
    name?: string | undefined;
    choosed?: boolean;

    constructor(data?: IProjectForAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.choosed = _data["choosed"];
        }
    }

    static fromJS(data: any): ProjectForAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectForAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["choosed"] = this.choosed;
        return data;
    }
}

export interface IProjectForAdminDto {
    id?: number;
    name?: string | undefined;
    choosed?: boolean;
}

export class PropertyDto implements IPropertyDto {
    id?: number;
    data?: DataPropertyDto;

    constructor(data?: IPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.data = _data["data"] ? DataPropertyDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyDto {
    id?: number;
    data?: DataPropertyDto;
}

export class PushPropertiesForModelRequest implements IPushPropertiesForModelRequest {
    modelId?: number;
    properties?: PropertyDto[] | undefined;

    constructor(data?: IPushPropertiesForModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PushPropertiesForModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PushPropertiesForModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPushPropertiesForModelRequest {
    modelId?: number;
    properties?: PropertyDto[] | undefined;
}

export class PushPropertiesForModelResponse implements IPushPropertiesForModelResponse {
    ok?: boolean;

    constructor(data?: IPushPropertiesForModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PushPropertiesForModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushPropertiesForModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPushPropertiesForModelResponse {
    ok?: boolean;
}

export class PushTreeDataToModelRequest implements IPushTreeDataToModelRequest {
    modelId?: number;
    ifcTree?: string | undefined;

    constructor(data?: IPushTreeDataToModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.ifcTree = _data["ifcTree"];
        }
    }

    static fromJS(data: any): PushTreeDataToModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PushTreeDataToModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["ifcTree"] = this.ifcTree;
        return data;
    }
}

export interface IPushTreeDataToModelRequest {
    modelId?: number;
    ifcTree?: string | undefined;
}

export class PushTreeDataToModelResponse implements IPushTreeDataToModelResponse {
    ok?: boolean;

    constructor(data?: IPushTreeDataToModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): PushTreeDataToModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PushTreeDataToModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IPushTreeDataToModelResponse {
    ok?: boolean;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshTokenRequest {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
}

export class RefreshTokenResponse implements IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;

    constructor(data?: IRefreshTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.refreshToken = _data["refreshToken"];
            this.expireAt = _data["expireAt"] ? new Date(_data["expireAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RefreshTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["refreshToken"] = this.refreshToken;
        data["expireAt"] = this.expireAt ? this.expireAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRefreshTokenResponse {
    accessToken?: string | undefined;
    refreshToken?: string | undefined;
    expireAt?: Date;
}

export class ResetPasswordAdminRequest implements IResetPasswordAdminRequest {
    id?: number;

    constructor(data?: IResetPasswordAdminRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ResetPasswordAdminRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordAdminRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IResetPasswordAdminRequest {
    id?: number;
}

export class ResetPasswordAdminResponse implements IResetPasswordAdminResponse {
    newPassword?: string | undefined;

    constructor(data?: IResetPasswordAdminResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordAdminResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordAdminResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IResetPasswordAdminResponse {
    newPassword?: string | undefined;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email?: string | undefined;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IResetPasswordRequest {
    email?: string | undefined;
}

export class ResetPasswordResponse implements IResetPasswordResponse {
    ok?: boolean;

    constructor(data?: IResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): ResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IResetPasswordResponse {
    ok?: boolean;
}

export class SendConsultRequestResponse implements ISendConsultRequestResponse {
    ok?: boolean;

    constructor(data?: ISendConsultRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SendConsultRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendConsultRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISendConsultRequestResponse {
    ok?: boolean;
}

export class SendDiscountRequestResponse implements ISendDiscountRequestResponse {
    ok?: boolean;

    constructor(data?: ISendDiscountRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SendDiscountRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendDiscountRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISendDiscountRequestResponse {
    ok?: boolean;
}

export class SendProjectBudgetToClientResponse implements ISendProjectBudgetToClientResponse {
    ok?: boolean;

    constructor(data?: ISendProjectBudgetToClientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): SendProjectBudgetToClientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendProjectBudgetToClientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface ISendProjectBudgetToClientResponse {
    ok?: boolean;
}

export enum UndergroundMaterial {
    Sand = 1,
    Rock = 2,
    Jil = 3,
    Stones = 4,
}

export class UpdateBudgetItemDescriptionsRequest implements IUpdateBudgetItemDescriptionsRequest {
    id?: number;
    description?: string | undefined;
    contractDescription?: string | undefined;

    constructor(data?: IUpdateBudgetItemDescriptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.contractDescription = _data["contractDescription"];
        }
    }

    static fromJS(data: any): UpdateBudgetItemDescriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetItemDescriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["contractDescription"] = this.contractDescription;
        return data;
    }
}

export interface IUpdateBudgetItemDescriptionsRequest {
    id?: number;
    description?: string | undefined;
    contractDescription?: string | undefined;
}

export class UpdateBudgetItemDescriptionsResponse implements IUpdateBudgetItemDescriptionsResponse {
    ok?: boolean;

    constructor(data?: IUpdateBudgetItemDescriptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateBudgetItemDescriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetItemDescriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateBudgetItemDescriptionsResponse {
    ok?: boolean;
}

export class UpdateBudgetItemTemplateRequest implements IUpdateBudgetItemTemplateRequest {
    budgetItem?: BudgetItemTemplateDto;

    constructor(data?: IUpdateBudgetItemTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetItem = _data["budgetItem"] ? BudgetItemTemplateDto.fromJS(_data["budgetItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateBudgetItemTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetItemTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetItem"] = this.budgetItem ? this.budgetItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateBudgetItemTemplateRequest {
    budgetItem?: BudgetItemTemplateDto;
}

export class UpdateBudgetItemTemplateResponse implements IUpdateBudgetItemTemplateResponse {
    budgetItemUpdated?: BudgetItemTemplateDto;

    constructor(data?: IUpdateBudgetItemTemplateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetItemUpdated = _data["budgetItemUpdated"] ? BudgetItemTemplateDto.fromJS(_data["budgetItemUpdated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateBudgetItemTemplateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetItemTemplateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetItemUpdated"] = this.budgetItemUpdated ? this.budgetItemUpdated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateBudgetItemTemplateResponse {
    budgetItemUpdated?: BudgetItemTemplateDto;
}

export class UpdatePartnerRequest implements IUpdatePartnerRequest {
    partner?: PartnerDto;

    constructor(data?: IUpdatePartnerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partner = _data["partner"] ? PartnerDto.fromJS(_data["partner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePartnerRequest {
    partner?: PartnerDto;
}

export class UpdatePartnerResponse implements IUpdatePartnerResponse {
    partnerUpdated?: PartnerDto;

    constructor(data?: IUpdatePartnerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerUpdated = _data["partnerUpdated"] ? PartnerDto.fromJS(_data["partnerUpdated"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePartnerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePartnerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partnerUpdated"] = this.partnerUpdated ? this.partnerUpdated.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdatePartnerResponse {
    partnerUpdated?: PartnerDto;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    orderNumber?: string | undefined;
    description?: string | undefined;
    partnerName?: string | undefined;
    partnerContactEmail?: string | undefined;
    partnerContactPhone?: string | undefined;
    ordererPartnerId?: number | undefined;
    supplierPartnerId?: number | undefined;
    undergroundMaterial?: UndergroundMaterial;
    landType?: LandType;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    longitudeOfBelts?: number;
    area?: number;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.orderNumber = _data["orderNumber"];
            this.description = _data["description"];
            this.partnerName = _data["partnerName"];
            this.partnerContactEmail = _data["partnerContactEmail"];
            this.partnerContactPhone = _data["partnerContactPhone"];
            this.ordererPartnerId = _data["ordererPartnerId"];
            this.supplierPartnerId = _data["supplierPartnerId"];
            this.undergroundMaterial = _data["undergroundMaterial"];
            this.landType = _data["landType"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.longitudeOfBelts = _data["longitudeOfBelts"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["orderNumber"] = this.orderNumber;
        data["description"] = this.description;
        data["partnerName"] = this.partnerName;
        data["partnerContactEmail"] = this.partnerContactEmail;
        data["partnerContactPhone"] = this.partnerContactPhone;
        data["ordererPartnerId"] = this.ordererPartnerId;
        data["supplierPartnerId"] = this.supplierPartnerId;
        data["undergroundMaterial"] = this.undergroundMaterial;
        data["landType"] = this.landType;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["longitudeOfBelts"] = this.longitudeOfBelts;
        data["area"] = this.area;
        return data;
    }
}

export interface IUpdateProjectRequest {
    id?: number;
    name?: string | undefined;
    orderNumber?: string | undefined;
    description?: string | undefined;
    partnerName?: string | undefined;
    partnerContactEmail?: string | undefined;
    partnerContactPhone?: string | undefined;
    ordererPartnerId?: number | undefined;
    supplierPartnerId?: number | undefined;
    undergroundMaterial?: UndergroundMaterial;
    landType?: LandType;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    longitudeOfBelts?: number;
    area?: number;
}

export class UpdateProjectResponse implements IUpdateProjectResponse {
    ok?: boolean;

    constructor(data?: IUpdateProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateProjectResponse {
    ok?: boolean;
}

export class UpdateUserRequest implements IUpdateUserRequest {
    id?: number;
    email?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: IUpdateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): UpdateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IUpdateUserRequest {
    id?: number;
    email?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export class UpdateUserResponse implements IUpdateUserResponse {
    ok?: boolean;

    constructor(data?: IUpdateUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): UpdateUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IUpdateUserResponse {
    ok?: boolean;
}

export class UploadImageForProjectResponse implements IUploadImageForProjectResponse {
    imageDownloadUri?: string | undefined;

    constructor(data?: IUploadImageForProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageDownloadUri = _data["imageDownloadUri"];
        }
    }

    static fromJS(data: any): UploadImageForProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadImageForProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageDownloadUri"] = this.imageDownloadUri;
        return data;
    }
}

export interface IUploadImageForProjectResponse {
    imageDownloadUri?: string | undefined;
}

export class UserDto implements IUserDto {
    id?: number;
    email?: string | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.name = _data["name"];
            this.companyName = _data["companyName"];
            this.isAdmin = _data["isAdmin"];
            this.isSuperAdmin = _data["isSuperAdmin"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["name"] = this.name;
        data["companyName"] = this.companyName;
        data["isAdmin"] = this.isAdmin;
        data["isSuperAdmin"] = this.isSuperAdmin;
        return data;
    }
}

export interface IUserDto {
    id?: number;
    email?: string | undefined;
    name?: string | undefined;
    companyName?: string | undefined;
    isAdmin?: boolean;
    isSuperAdmin?: boolean;
}

export class UserForProjectDto implements IUserForProjectDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;

    constructor(data?: IUserForProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserForProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserForProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IUserForProjectDto {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}